<template>
  <div class="export-container">
    <div class="button-group">
      <el-button
        type="primary"
        icon="el-icon-download"
        @click="exportModuleClick"
      >
        导出模型
      </el-button>
      <!-- <el-button
        type="primary"
        icon="el-icon-picture"
        @click="exportPlaneClick"
      >
        导出平面图
      </el-button> -->
      <el-button
        type="primary"
        icon="el-icon-picture"
        id="export-building-plane-btn"
        @click="exportBuildingPlaneClick"
      >
        导出建筑平面图
      </el-button>
      <el-button
        type="primary"
        icon="el-icon-picture"
        @click="exportStructurePlaneClick"
        id="export-structure-plane-btn"
      >
        导出结构平面图
      </el-button>
      <el-button
        type="primary"
        icon="el-icon-map-location"
        @click="exportPointSinksClick"
        id="export-point-sinks-btn"
      >
        导出测点图(沉降)
      </el-button>
      <el-button
        type="primary"
        icon="el-icon-map-location"
        @click="exportPointTiltClick"
        id="export-point-tilt-btn"
      >
        导出测点图(倾斜)
      </el-button>
      <el-button
        type="primary"
        icon="el-icon-map-location"
        @click="exportFloorCrackClick"
        id="export-floor-crack-btn"
      >
        导出地坪开裂
      </el-button>
      <!-- <el-button
        type="primary"
        icon="el-icon-map-location"
        @click="exportJpgClick"
      >
        导出JPG
      </el-button> -->
    </div>
  </div>
</template>

<script>
import { exportData } from "@/api/upload";
import { mapGetters } from "vuex";
import {
  showFullScreenLoading,
  tryHideFullScreenLoading,
} from "@/utils/loading";
import {
  SettlementDetectionList,
  ShearingObliqueList,
  SpaceList,
} from "@/api/modelingList";
import {
  drawSvg,
  delMeasurePoint,
} from "@/views/inspectionLite/viewLite/inspect/viewData/liteDraw";
import { changeFloorSrd } from "@/utils/rlModuleUtils";
import {
  exportDwg,
  zipFile,
  uploadJpg,
  showHideLine,
  getCheckStatus,
  buildingPlaneSetting,
  structurePlaneSetting,
  drawAnyLine,
} from "./derive.js";
import { changeBackgroundGrid } from "@/views/inspectionLite/components/ModulePage/utils/settingBtn.js";
import { updateAxisData } from "@/rlMxModules/operate/operateAxisData";
import { transferLocalData } from "@/utils/indexedDBModule/saveAllModules.js";
import { rlTextData } from "@/rlMxModules/rlDataClass/rlTextData.js";
import { isCorrectedWallBeamCol } from "@/rlMxModules/operate/operateApi.js";
import { McGePoint3d, McCmColor } from "mxcad";
export default {
  name: "Derive",
  computed: {
    ...mapGetters([
      "rlProject_id",
      "rl_floor_id",
      "rl_floor_arr",
      "rlProject_name",
      "rlBuilding",
      "isSaveLoading",
    ]),
  },
  watch: {
    async isSaveLoading(newVal) {
      console.log("newVal", newVal, this.isNext);

      if (!newVal && this.isNext) {
        try {
          this.isNext = false;
          await new Promise((resolve) => setTimeout(resolve, 5000));
          const { data } = await exportData({
            project_id: this.rlProject_id,
            type: exportType,
          });
          if (data.url) {
            const iframe = document.createElement("iframe");
            iframe.style.display = "none";
            iframe.src = data.url;
            iframe.onload = () => {
              document.body.removeChild(iframe);
            };
            document.body.appendChild(iframe);
          }
          this.$message.success("导出成功");
          tryHideFullScreenLoading();
        } catch (error) {
          tryHideFullScreenLoading();
        }
      }
    },
  },
  data() {
    return {
      date: "",
      gridShow: true,
      isNext: false,
    };
  },
  created() {
    const time = new Date();
    // 获取当前日期,格式:20250307
    this.date =
      time.getFullYear() +
      (time.getMonth() + 1).toString().padStart(2, "0") +
      time.getDate().toString().padStart(2, "0");
    let TempGridShow = localStorage.getItem("uSettings");
    if (TempGridShow) {
      TempGridShow = JSON.parse(TempGridShow);
      this.gridShow = TempGridShow.gridShow;
    }
  },
  methods: {
    // 导出模型
    async exportModuleClick() {
      try {
        // 显示选择框让用户选择导出类型
        let exportType = "";
        try {
          await this.$confirm(
            "请选择导出格式(YDB:盈建科和PKPM,JWD:PKPM)",
            "导出模型",
            {
              confirmButtonText: "YDB",
              cancelButtonText: "JWD",
              distinguishCancelAndClose: true,
              type: "info",
              center: true,
              customClass: "export-type-dialog",
              cancelButtonClass: "jwd-btn-dialog",
              confirmButtonClass: "ydb-btn-dialog",
            }
          );
          // 点击确认按钮 => PKPM
          exportType = "YJK";
        } catch (confirmError) {
          // 取消 => 盈建科；关闭 => 直接返回
          if (confirmError === "cancel") {
            exportType = "PKPM";
          } else {
            // 用户关闭了对话框，不进行导出
            return;
          }
        }

        // 如果用户选择了导出类型，继续执行导出逻辑
        if (!exportType) {
          this.$message.error("请选择导出类型");
          return;
        }

        showFullScreenLoading("导出中...");
        //判断是否存在墙梁柱未转正
        if (!(await isCorrectedWallBeamCol())) {
          this.$message.warning("存在未转正的墙梁柱,请注意核查！");
        }
        this.isNext = true;
        //更新轴线数据
        await updateAxisData(true);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await transferLocalData(this.rlProject_id, "modelingData", 1);

        // 延迟五秒后继续下面的处理
        await new Promise((resolve) => setTimeout(resolve, 5000));
        if (this.isSaveLoading) {
          this.$message.error("模型数据保存中,请等待保存完成后重试");
          tryHideFullScreenLoading();
          return;
        }
        console.log("this.isSaveLoading", this.isSaveLoading);

        if (!this.isSaveLoading) {
          this.isNext = false;
          const { data } = await exportData({
            project_id: this.rlProject_id,
            type: exportType,
          });
          if (data.url) {
            const iframe = document.createElement("iframe");
            iframe.style.display = "none";
            iframe.src = data.url;
            iframe.onload = () => {
              document.body.removeChild(iframe);
            };
            document.body.appendChild(iframe);
          }
          this.$message.success("导出成功");
          tryHideFullScreenLoading();
        }
      } catch (error) {
        this.$message.error("导出失败，请稍后重试" + error);
        tryHideFullScreenLoading();
      }
    },
    // 导出平面图
    async exportPlaneClick() {
      await this.exportPlane("平面图");
    },

    // 导出平面图
    async exportPlane(name) {
      try {
        showFullScreenLoading("导出中...");
        const filePathUrls = [];
        //隐藏背景栅格
        changeBackgroundGrid(false);
        if (this.rl_floor_arr && Array.isArray(this.rl_floor_arr)) {
          for (const item of this.rl_floor_arr) {
            if (item) {
              try {
                // 切换楼层
                await changeFloorSrd(item);
                //隐藏房间的二维线段
                await showHideLine(false);
                if (name == "建筑平面图") {
                  await buildingPlaneSetting(true);
                } else if (name == "结构平面图") {
                  await structurePlaneSetting(true);
                }
                const fileName =
                  this.rlProject_name +
                  "_" +
                  item.Name +
                  "_" +
                  this.date +
                  name +
                  ".dwg";
                const result = await exportDwg(fileName);
                if (result) {
                  filePathUrls.push(result);
                }
                //显示房间的二维线段
                await showHideLine(true);
                if (name == "建筑平面图") {
                  await buildingPlaneSetting(false);
                } else if (name == "结构平面图") {
                  await structurePlaneSetting(false);
                }
              } catch (error) {
                //显示房间的二维线段
                await showHideLine(true);
                if (name == "建筑平面图") {
                  await buildingPlaneSetting(false);
                } else if (name == "结构平面图") {
                  await structurePlaneSetting(false);
                }
                throw error;
              }
            }
          }
        }

        await zipFile(filePathUrls, "_" + name);
        //显示背景栅格
        if (this.gridShow) changeBackgroundGrid(true);
        tryHideFullScreenLoading();
      } catch (error) {
        console.log("导出平面图error", error);
        this.$message.error("导出失败");
        tryHideFullScreenLoading();
      }
    },
    // 导出测点图（沉降）
    async exportPointSinksClick() {
      try {
        showFullScreenLoading("导出中...");
        // 切换楼层
        //隐藏背景栅格
        changeBackgroundGrid(false);
        if (
          !this.rl_floor_arr ||
          !Array.isArray(this.rl_floor_arr) ||
          this.rl_floor_arr.length <= 0
        ) {
          tryHideFullScreenLoading();
          return null;
        }
        await changeFloorSrd(this.rl_floor_arr[0]);
        //隐藏房间的二维线段
        await showHideLine(false);
        await structurePlaneSetting(true, "沉降测点图");
        // 获取测点
        const { data } = await SettlementDetectionList({
          project_id: this.rlProject_id,
        });
        // 绘制测点
        let svgids = [];
        if (data.siteList && data.siteList.length > 0) {
          for (const item of data.siteList) {
            let text = new rlTextData();
            let pt = new McGePoint3d(item.pt1.x, item.pt1.y, item.pt1.z);
            text.position = pt;
            text.Text = item.No_ + "#";
            text.textType = "导出图纸";
            text.draw(true);
            let textObj = text.mcDbId.getMcDbEntity();
            textObj.alignmentPoint = textObj.position = pt;
            svgids.push(text.mcDbId);
            // var addObj = await drawSvg(data.siteList, item.pt1, item.No_);
            // Object.assign(item, addObj);
          }
        }
        const fileName =
          this.rlProject_name + "_" + this.date + "沉降测点图.dwg";
        // 导出平面图
        const filePathUrls = [];
        filePathUrls.push(await exportDwg(fileName));
        await zipFile(filePathUrls, "_沉降测点图");
        // 删除测点
        // await delMeasurePoint(data.siteList, ["svgId", "textId", "circleId"]);
        for (const item of svgids) {
          item.erase();
        }
        //显示背景栅格
        if (this.gridShow) changeBackgroundGrid(true);
        //显示房间的二维线段
        await showHideLine(true);
        await structurePlaneSetting(false, "沉降测点图");
        tryHideFullScreenLoading();
      } catch (error) {
        console.log("导出测点图(沉降)error", error);
        //恢复结构平面图
        await structurePlaneSetting(false, "沉降测点图", false);
        tryHideFullScreenLoading();
      }
    },
    // 导出测点图（倾斜）
    async exportPointTiltClick() {
      try {
        showFullScreenLoading("导出中...");
        //隐藏背景栅格
        changeBackgroundGrid(false);
        // 获取测点
        const { data } = await ShearingObliqueList({
          project_id: this.rlProject_id,
        });

        const currFlrId = this.rlBuilding;

        let floorSiteList = {};
        if (data.siteList && data.siteList.length > 0) {
          // 按楼层id分组测点
          floorSiteList = data.siteList.reduce((acc, item) => {
            const floorId = item.floorGuid;
            if (!acc[floorId]) {
              acc[floorId] = [];
            }
            acc[floorId].push(item);
            return acc;
          }, {});
        }

        const filePathUrls = [];
        for (const floor in floorSiteList) {
          const siteList = floorSiteList[floor];
          // 查找确认楼层数据是否存在
          let floorId = null;
          if (this.rl_floor_arr && Array.isArray(this.rl_floor_arr)) {
            for (const item of this.rl_floor_arr) {
              if (item && item.Guid == floor) {
                floorId = item;
                break;
              }
            }
          }
          if (floorId) {
            try {
              // 切换楼层
              await changeFloorSrd(floorId);
              //隐藏房间的二维线段
              await showHideLine(false);
              await structurePlaneSetting(true, "倾斜测点图");
              // const drawsiteList = []; // 实际绘制的测点
              // 绘制测点
              let svgids = [];
              for (const item of siteList) {
                let text = new rlTextData();
                let pt = new McGePoint3d(item.pt1.x, item.pt1.y, item.pt1.z);
                text.position = pt;
                text.Text = item.No_ + "#";
                text.textType = "导出图纸";
                text.draw(true);
                let textObj = text.mcDbId.getMcDbEntity();
                textObj.alignmentPoint = textObj.position = pt;
                svgids.push(text.mcDbId);
                // var addObj = await drawSvg(siteList, item.pt1, item.No_);
                // Object.assign(item, addObj);
                // drawsiteList.push(item);
              }
              const fileName =
                this.rlProject_name +
                "_" +
                floorId.Name +
                "_" +
                this.date +
                "倾斜测点图.dwg";
              filePathUrls.push(await exportDwg(fileName));
              // 删除测点
              // await delMeasurePoint(drawsiteList, [
              //   "svgId",
              //   "textId",
              //   "circleId",
              // ]);
              for (const item of svgids) {
                item.erase();
              }
              //显示房间的二维线段
              await showHideLine(true);
              await structurePlaneSetting(false, "倾斜测点图");
            } catch (error) {
              //显示房间的二维线段
              await showHideLine(true);
              await structurePlaneSetting(false, "倾斜测点图");
              throw error;
            }
          }
        }
        await zipFile(filePathUrls, "_倾斜测点图");
        //显示背景栅格
        if (this.gridShow) changeBackgroundGrid(true);
        await changeFloorSrd(currFlrId); //重新切换回原显示楼层
        tryHideFullScreenLoading();
      } catch (error) {
        console.log("导出测点图(倾斜)error", error);
        tryHideFullScreenLoading();
      }
    },
    // 导出JPG
    async exportJpgClick() {
      try {
        showFullScreenLoading("导出中...");
        await uploadJpg();
        tryHideFullScreenLoading();
      } catch (error) {
        console.log("error", error);
        this.$message.error("导出失败");
        tryHideFullScreenLoading();
      }
    },
    // 导出建筑平面图
    async exportBuildingPlaneClick() {
      // 导出建筑平面图
      await this.exportPlane("建筑平面图");
    },

    // 导出结构平面图
    async exportStructurePlaneClick() {
      // 导出结构平面图
      await this.exportPlane("结构平面图");
    },
    // 导出地坪开裂
    async exportFloorCrackClick() {
      try {
        showFullScreenLoading("导出中...");
        if (
          !this.rl_floor_arr ||
          !Array.isArray(this.rl_floor_arr) ||
          this.rl_floor_arr.length <= 0
        ) {
          tryHideFullScreenLoading();
          return null;
        }
        // 切换楼层
        // await changeFloorSrd(this.rl_floor_arr[0]);
        // 获取测点
        const { data } = await SpaceList({
          project_id: this.rlProject_id,
        });
        if (!data || data.floor_cracking.length <= 0) {
          tryHideFullScreenLoading();
          return null;
        }
        const floor_cracking = data.floor_cracking;
        let flrData = [];
        for (const item of floor_cracking) {
          let index = -1;
          let Guid = "";
          if (item.flrGuid) {
            Guid = item.flrGuid;
          } else {
            Guid = this.rl_floor_arr[0].Guid;
          }
          index = flrData.findIndex((flr) => flr.flrGuid == Guid);
          if (index == -1) {
            flrData.push({
              flrGuid: item.flrGuid,
              floor_cracking: [item],
            });
          } else flrData[index].floor_cracking.push(item);
        }
        // console.log("flrData", flrData);

        //隐藏背景栅格
        changeBackgroundGrid(false);
        const filePathUrls = [];
        for (const item of flrData) {
          let flrIndex = this.rl_floor_arr.findIndex(
            (flr) => flr.Guid == item.flrGuid
          );
          if (flrIndex != -1) {
            await changeFloorSrd(this.rl_floor_arr[flrIndex]);
            await showHideLine(false);
            await structurePlaneSetting(true, "地坪开裂图");

            // 绘制测点
            await drawAnyLine(item.floor_cracking);
            const fileName =
              this.rlProject_name +
              "_" +
              this.date +
              this.rl_floor_arr[flrIndex].Name +
              "地坪开裂图.dwg";
            // 导出平面图
            filePathUrls.push(await exportDwg(fileName));
            // 删除测点
            // 清空画布上的裂缝数据
            await delMeasurePoint(item.floor_cracking, [
              "lineId",
              "textId",
              "circleId",
            ]);
            //显示房间的二维线段
            await showHideLine(true);
            await structurePlaneSetting(false, "地坪开裂图");
          }
        }
        await zipFile(filePathUrls, "_地坪开裂图");
        // //隐藏房间的二维线段
        // await showHideLine(false);
        // await structurePlaneSetting(true, "地坪开裂图");

        // // 绘制测点
        // await drawAnyLine(floor_cracking);
        // const fileName =
        //   this.rlProject_name + "_" + this.date + "地坪开裂图.dwg";
        // // 导出平面图
        // const filePathUrls = [];
        // filePathUrls.push(await exportDwg(fileName));
        // await zipFile(filePathUrls, "_地坪开裂图");
        // // 删除测点
        // // 清空画布上的裂缝数据
        // await delMeasurePoint(floor_cracking, ["lineId", "textId", "circleId"]);
        // //显示房间的二维线段
        // await showHideLine(true);
        // await structurePlaneSetting(false, "地坪开裂图");
        //显示背景栅格
        if (this.gridShow) changeBackgroundGrid(true);
        tryHideFullScreenLoading();
      } catch (error) {
        console.log("导出地坪开裂error", error);
        //恢复结构平面图
        await structurePlaneSetting(false, "地坪开裂图", false);
        tryHideFullScreenLoading();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.export-container {
  padding: 5px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .button-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
    padding: 10px;

    .el-button {
      padding: 8px 12px;
      width: 100%;
      max-width: 200px;
      margin: 0 auto;

      &:hover {
        opacity: 0.9;
      }
    }
  }
}
</style>
